import CommonConst from '@/constants/CommonConst';

export function checkMobileScreen() {
	return window.innerWidth <= CommonConst.MOBILE_SCREEN_MAX_WIDTH;
}
